import React, {useEffect, useState, memo, Fragment} from 'react';
import {    
    Button,
    Dialog,
    DialogActions,
    DialogContent, 
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    LinearProgress,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import { 
    AccountCircle as AccountCircleIcon,
    Close as CloseIcon,
    CompassCalibration as CompassCalibrationIcon,
    Delete as DeleteIcon,
    Http as HttpIcon,
    Info as InfoIcon,
    Nature as NatureIcon,
    Person as PersonIcon,
    Edit as EditIcon,
    ListAlt as ListAltIcon,
    Save as SaveIcon,
    SettingsInputAntenna as SettingsInputAntennaIcon,
    SignalWifi4Bar as SignalWifi4BarIcon,
    VpnKey as VpnKeyIcon,
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon
} from '@material-ui/icons';
import { red } from '@material-ui/core/colors';
import { makeStyles, withStyles  } from '@material-ui/core/styles';
import { SnackbarProvider, useSnackbar } from 'notistack';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { Alert } from '@material-ui/lab';
import FacebookCircularProgress from '../Elementos/FacebookCircularProgress';
import styled from 'styled-components';
import { Autocomplete } from '@material-ui/lab';
import Swal from 'sweetalert2';
import { Scrollbars } from 'react-custom-scrollbars-2';

const TrYounetStyled = styled.tr`
    display:flex;
    z-index:2;
    background-color:${props => props.selected ? 'LightBlue' : '#fff'};
    &:hover{
        background-color:Gainsboro
    }
`;

const TdYounetStyled = styled.td`
    color:${props => props.color ? props.color : 'black'};
    font-size:${props => props.fontSize ?  props.fontSize : '10px'};
    font-weight:${props => props.bolder ? 'bold' : 'none'};
    min-width:${props => props.minWidth || 100};
    width:${props => props.width || 100};
    padding-top:${props => props.element ? '0px' : '5px'}; 
    text-align:${props => props.align ? props.align : 'left'};
    background:transparent;
    border-bottom: 1px solid #E5E8E8;
    display:block;
    height:40px;
    max-height:40px;
    padding:8px;   
    position:relative;
    left:0px;      
    text-overflow: ellipsis;    
    white-space: nowrap; 
    overflow: hidden;
    line-height:25px;
`;

const TheadYounetStyled = styled.th`
    text-align:${props => props.align ? props.align : 'left'};
    min-width:${props => props.width || 60};
    width:${props => props.width || 100};
    background-color:#0E3B5F;
    color: #fff;
    display:block;
    font-weight:bold, 
    height:33px;
    max-height:33px;
    padding-left:10px;
    padding-top:6px;
    position: relative;
    left:0px;   
`;

const TheadYounet = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, align})=>( 
    <TheadYounetStyled width={widthDefault} align={align}>
        <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : 'asc'}
            onClick={createSortHandler(headCell.id)} 
            style={{color:'#fff', textAlign:align}}
        >
            {headCell.label}
            {orderBy === headCell.id ? (
            <span className={classes.visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
            </span>
            ) : null}
        </TableSortLabel>
    </TheadYounetStyled>
));

const columns = [
    { id: 'Action', label: 'Action', minWidth: 204.5,numeric: false, disablePadding: false },
    { id: 'Zona', label: 'Zona', minWidth: 140,numeric: false, disablePadding: false },
    { id: 'IP', label: 'IP', minWidth: 140,numeric: false, disablePadding: false },
    { id: 'SSID', label: 'SSID', minWidth: 150,numeric: false, disablePadding: false },
    { id: 'Frecuencia', label: 'Frecuencia', minWidth: 110, numeric: false, disablePadding: false },
    { id: 'Marca', label: 'Marca', minWidth: 170, numeric: false, disablePadding: false },
    { id: 'Modelo', label: 'Modelo', minWidth: 170, numeric: false, disablePadding: false}, 
    { id: 'Tipo', label: 'Tipo', minWidth: 120, numeric: false, disablePadding: false}, 
    { id: 'Usuario', label: 'Usuario', minWidth: 145, numeric: false, disablePadding: false}, 
    { id: 'Password', label: 'Password', minWidth: 165, numeric: true, disablePadding: false}, 
];

const styles2 = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: red[900],
    },
});

const DialogTitle = withStyles(styles2)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
});

const styles = makeStyles((theme)=>({
    paper:{
        padding:20
    },
    button:{
        color:'#fff'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

function capitalize(word) { return word[0].toUpperCase() + word.slice(1); };

const RowAp = ({rowInfo, handleDelete, dataZona, handleUpdate, ModelosList, Marcas, Tipos})=>{
    const { enqueueSnackbar } = useSnackbar();
    const [ openDialog, setOpenDialog ] = useState(false);
    const [ openDialogInformacion, setOpenDialogInformacion ] = useState(false);    
    const [ openDialogInformacionCPE, setOpenDialogInformacionCPE ] = useState(false);
    const [ informacionAP, setInformacionAP ] = useState({});
    const [ continuoInformacion, setContinuoInformacion ] = useState(false);
    const [ informacionAPCPE, setInformacionAPCPE ] = useState([]);
    const [ continuoInformacionCPE, setContinuoInformacionCPE ] = useState(false);
    const [ openDialogInformacion2, setOpenDialogInformacion2 ] = useState(false);
    const [ continuoInformacion2, setContinuoInformacion2 ] = useState(false);
    const [ informacion, setInformacion ] = useState({});
    const [ showPass, setShowPass ] = useState(false);
    const [ openDialogEditInformacion, setOpenDialogEditInformacion ] = useState(false);
    const [ Datos, setDatos ] = useState({ 
        Marca:'', 
        Modelo:'', 
        Tipo:'', 
        Puerto:'', 
        IP:'192.168', 
        Usuario:'admin', 
        Password:'',
        Frecuencia:'',
        SSID:'',
        KEY:'',
        isLocal:false,
        Comentario:'',
    });
    const [ Modelos, setModelos ] = useState([]);
    const [ isDisableTipo, setDisableTipo ] = useState(false);
    const [ isDisableModelo, setDisableModelo ] = useState(false);
    const [ isSelectedZona, setSelectedZona ] = useState(true);
    const [ isProcessing, setProcessing ] = useState(false);
    const [ isInfoCharging, setInfoCharging ] = useState(false);

    useEffect(()=>{
        if(continuoInformacion){
            setContinuoInformacion(false);
            setOpenDialogInformacion(true);
        }
    },[continuoInformacion]);

    useEffect(()=>{
        if(continuoInformacion2){
            setContinuoInformacion2(false);
            setOpenDialogInformacion2(true);
        }
    },[continuoInformacion2]);

    useEffect(()=>{
        if(continuoInformacionCPE){
            setContinuoInformacionCPE(false);
            setOpenDialogInformacionCPE(true);
        }
    },[continuoInformacionCPE])
    
    const handleSubDelete = ()=>{
        fetch('api/equipos',{
            method:'DELETE',
            body: JSON.stringify({_id:rowInfo._id}),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                handleDelete(rowInfo)            
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
            }
        });
    };

    const handleAlert = ()=>{setOpenDialog(true);};

    const handleAlertClose = ()=>{setOpenDialog(false);};

    const handleAlertCloseInformacion = ()=>{setOpenDialogInformacion(false);};

    const handleAlertCloseInformacion2 = ()=>{setOpenDialogInformacion2(false);};

    const handleAlertCloseCPE = ()=>{ setOpenDialogInformacionCPE(false); };

    const handleInformacionAP = ()=>{
        if(rowInfo.isLocal){ 
            setInfoCharging(true);
            fetch('api/mikrotik/ap',{
                method:'POST',
                body: JSON.stringify(rowInfo),
                headers:{'Content-Type': 'application/json'}
            }) 
            .then(response=> response.json())
            .then(result =>{
                console.log(result)
                if(result.status){
                    Swal.fire({
                        title:result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        toast:true,
                    });
                    setInfoCharging(false);
                }else{
                    const objeto = {};
                    for(const [key, value] of Object.entries(result)){
                        const splitKey = key.split('-');
                        switch(splitKey.length){
                            case 1: 
                                objeto[key] = value; 
                                break;
                            case 2: 
                                let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                objeto[key2] = value; 
                                break;
                            case 3: 
                                let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                objeto[key3] = value; 
                                break;
                            case 4: 
                                let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                objeto[key4] = value; 
                                break;
                            default:
                                objeto[key] = value; 
                                break;
                        }
                    }
                    setInformacionAP(objeto);
                    setContinuoInformacion(true);
                    setInfoCharging(false);
                }
            });
        }else{
            Swal.fire({
                title:'Informacion No Disponible',
                icon:'info',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                toast:true,
            });
        }
    };

    const handleInformacionStatus = ()=>{
        if(rowInfo.isLocal){ 
            setInfoCharging(true);
            fetch('api/mikrotik/informacion',{
                method:'POST',
                body: JSON.stringify(rowInfo),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                console.log(result)
                if(result.status){
                    Swal.fire({
                        title:result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        toast:true,
                    })
                    setInfoCharging(false);
                }else{
                    const objeto = {};
                    result.forEach(value=>{
                        let splitKey = value.field.split('-');
                        switch(splitKey.length){
                            case 2: 
                                let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                objeto[key2] = value.value; 
                                break;
                            case 3: 
                                let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                objeto[key3] = value.value; 
                                break;
                            case 4: 
                                let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                objeto[key4] = value.value; 
                                break;
                            default:
                                objeto[value.field] = value.value; 
                                break;
                        }
                    })
                    setInformacion(objeto);
                    setContinuoInformacion2(true);
                    setInfoCharging(false);
                }
            }); 
        }else{
            Swal.fire({
                title:'Informacion No Disponible',
                icon:'info',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                toast:true,
            });
        }
    };

    const handleInformacionCPE = ()=>{
        if(rowInfo.isLocal){ 
            setInfoCharging(true);
            fetch('api/mikrotik/ap/cpe',{
                method:'POST',
                body: JSON.stringify(rowInfo),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                console.log(result)
                if(result.status){
                    Swal.fire({
                        title:result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        toast:true,
                    })
                    setInfoCharging(false);
                }else{
                    const arr = []
                    result.forEach(value2=>{
                        const objeto = {};
                        //console.log(value2)
                        for(const x of value2){
                            const splitKey = x.field.split('-');
                            switch(splitKey.length){
                                case 1: 
                                    objeto[x.field] = x.value; 
                                    break;
                                case 2: 
                                    let x2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                    objeto[x2] = x.value; 
                                    break;
                                case 3: 
                                    let x3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                    objeto[x3] = x.value; 
                                    break;
                                case 4: 
                                    let x4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                    objeto[x4] = x.value; 
                                    break;
                                default:
                                    objeto[x.field] = x.value; 
                                    break;
                            }
                        };
                        arr.push(objeto);
                    });
                    console.log(arr);
                    setInformacionAPCPE(arr);
                    setContinuoInformacionCPE(true);
                    setInfoCharging(false);
                }
            }); 
        }else{
            Swal.fire({
                title:'Informacion No Disponible',
                icon:'info',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                toast:true,
            });
        }
        
    };

    const handlePass = ()=>{ setShowPass(!showPass); };

    const handleClickEdit =  ()=>{
        setDatos(rowInfo);
        setOpenDialogEditInformacion(true);
    };

    const handleSelectMarca = (value)=>{
        setDatos({...Datos, Marca:value});
        setDisableTipo(false);
    };

    const handleClearMarca = ()=>{
        setDatos({...Datos, Marca:'', Tipo:'', Modelo:''});
        setDisableTipo(true);
        setDisableModelo(true);
        setModelos(ModelosList);
    };

    const handleSelectTipo = (value)=>{
        const arrF = Modelos.filter(value2=> value2.Tipo === value);
        const arrF2 = arrF.filter(value2=>value2.Marca === Datos.Marca);
        setModelos(arrF2);
        setDatos({...Datos, Tipo:value});
        setDisableModelo(false);
    };

    const handleClearTipo = ()=>{
        setDatos({...Datos, Tipo:'', Modelo:''});
        setDisableModelo(true);
        setModelos([]);
    };

    const handleClearZona = ()=>{
        setDatos({...Datos, Zona:''});
        setSelectedZona(false);
    };

    const handleSelectZona = (valZ)=>{
        setDatos({...Datos, Zona:valZ});
        setSelectedZona(true);
    }; 

    const handleSwitchLocal = ({target})=>{ setDatos({...Datos, isLocal:target.checked}) };

    const handleDatos = (e)=>{ setDatos({...Datos, [e.target.name]:e.target.value})};

    const handleAlertCloseEditInformacion = ()=>{
        setOpenDialogEditInformacion(false);
        setDatos({
            Marca:'', 
            Modelo:'', 
            Tipo:'', 
            Nombre:'', 
            IP:'192.168', 
            Usuario:'admin', 
            Password:'',
            Puerto:'',
            Frecuencia:'',
            SSID:'',
            KEY:'',
            Zona:'',
            isLocal:false
        });
    };

    const handleEditEquipo =()=>{
        setProcessing(true);
        const objeto = {...Datos};
        fetch('api/equipos',{
            method:'PUT',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                handleUpdate(objeto);
                enqueueSnackbar(result.message, {variant:'success'}); 
                setTimeout(()=>{
                    setProcessing(false);
                },1000)      
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setProcessing(false);
            }
        });
    };

    const handleComment = (comment)=>{
        Swal.fire({
            title:comment,
            icon:'info',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonColor:'#005596',
            width:600,
            confirmButtonText:'OK',
            toast:true
        })
    };

    const handleSelectModelo = (value)=>{ setDatos({...Datos, Modelo:value.toString().trim()});};

    const handleClearModelo = ()=>{setDatos({...Datos, Modelo:''});};

    return(
        <Fragment key={rowInfo.Mes}>
            <Dialog
                open={openDialog}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Desea Eliminar este Equipo"} </DialogTitle>
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                <Button onClick={handleSubDelete} color="primary" variant='contained' style={{color:'#fff'}}>
                    Si
                </Button>
                <Button onClick={handleAlertClose} color="default" variant='contained' style={{color:'#fff'}}>
                    No
                </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDialogInformacion}
                onClose={handleAlertCloseInformacion}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseInformacion}>
                    Informacion de A.P.
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="SSID" value={informacionAP.ssid} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="CIUDAD" value={informacionAP.country} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="FRECUENCIA" value={informacionAP.frequency} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="LIST SCAN" value={informacionAP.scanList} fullWidth/>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <TextField id="standard-basic" label="PASSWORD" value={informacionAP.nv2PresharedKey} fullWidth/>
                        </Grid>
                    </Grid>
                </DialogContent> 
            </Dialog>
            <Dialog
                open={openDialogInformacion2}
                onClose={handleAlertCloseInformacion2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseInformacion2}>
                    Informacion
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="FIRMWARE" value={informacion.version} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="MODELO" value={informacion.boardName} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="CPU" value={informacion.cpu} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="STATUS CPU %" value={informacion.cpuLoad} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="MEMORIA" value={informacion.totalMemory / 1048576} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="MEMORIA LIBRE" value={(informacion.freeMemory / 1048576).toFixed(2)} fullWidth/>
                        </Grid>
                    </Grid>
                </DialogContent> 
            </Dialog>
            <Dialog
                open={openDialogInformacionCPE}
                onClose={handleAlertCloseCPE}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth='md'
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseCPE}>
                    Informacion C.P.E.
                </DialogTitle>
                <DialogContent>
                    <Paper stye={{width:'100%'}}>
                        <TableContainer style={{maxHeight: 440}}>
                            <Table stickyHeader aria-label="simple table" >
                                <TableHead>
                                <TableRow>
                                    <TableCell>CLIENTE</TableCell>
                                    <TableCell>MAC</TableCell>
                                    <TableCell>ULTIMA ACTIVIDAD</TableCell>
                                    <TableCell>CCQ</TableCell>
                                    <TableCell>IP</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {informacionAPCPE.map((row) => (
                                    <TableRow key={row.name}>
                                        <TableCell > {row.radioName}</TableCell>
                                        <TableCell >{row.macAddress}</TableCell>
                                        <TableCell >{row.lastActivity}</TableCell>
                                        <TableCell >{`tx:${row.txCcq} rx:${row.rxCcq}`}</TableCell>
                                        <TableCell >{row.lastIp}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </DialogContent>
            </Dialog>
            <Dialog
                open={openDialogEditInformacion}
                onClose={handleAlertCloseEditInformacion}
                fullScreen
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseEditInformacion}>
                    Informacion de Equipo
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        {isProcessing ? <LinearProgress color='secondary' /> : <div style={{height:4}}></div>}
                        </Grid>     
                        <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                            <Autocomplete
                                id="Zona"
                                options={dataZona.map(value=>value.Zona)}
                                value={Datos.Zona || ''}                              
                                renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearZona()
                                    }else{
                                        handleSelectZona(value);
                                    }
                                }}  
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                            <Autocomplete
                                id="Marca"
                                options={Marcas.map(value=>value.Marca)}
                                value={Datos.Marca || ''}                              
                                renderInput={(params) => <TextField {...params} label="Marca" variant="outlined" size='small' fullWidth />}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearMarca()
                                    }else{
                                        handleSelectMarca(value);
                                    }
                                }}  
                            />
                        </Grid>                
                        <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                            <Autocomplete
                                id="Tipo"
                                options={Tipos.map(value=>value.Tipo)}
                                disabled={isDisableTipo}
                                value={Datos.Tipo || ''}                              
                                renderInput={(params) => <TextField {...params} label="Tipo" variant="outlined" size='small' fullWidth />}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearTipo()
                                    }else{
                                        handleSelectTipo(value);
                                    }
                                }}  
                            />
                        </Grid>   
                        <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                            <Autocomplete
                                id="Modelo"
                                options={Modelos.map(value=>value.Modelo)}
                                disabled={isDisableModelo}
                                value={Datos.Modelo || ''}                              
                                renderInput={(params) => <TextField {...params} label="Modelo" variant="outlined" size='small' fullWidth />}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearModelo()
                                    }else{
                                        handleSelectModelo(value);
                                    }
                                }}  
                            />
                        </Grid>   
                        <Grid item xl={2} lg={2} md={4} sm={6} xs={12}>
                            <TextField
                                value={Datos.Usuario || ''}
                                name='Usuario'
                                onChange={handleDatos}
                                label='Usuario'
                                fullWidth
                                size='small'
                                variant='outlined'      
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <PersonIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                         
                            />
                        </Grid>        
                        <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                            <TextField
                                value={Datos.Password || ''}
                                name='Password'
                                onChange={handleDatos}
                                label='Password'
                                fullWidth
                                size='small'
                                variant='outlined' 
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <VpnKeyIcon color='primary' />
                                    </InputAdornment>
                                    ),
                                }}                              
                            />
                        </Grid>       
                        <Grid item xl={3} lg={3} md={4} sm={5} xs={7}>
                            <TextField
                                value={Datos.IP || ''}
                                name='IP'
                                onChange={handleDatos}
                                label='IP'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <HttpIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                               
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={3} xs={5}>
                            <TextField
                                value={Datos.Puerto || ''}
                                name='Puerto'
                                onChange={handleDatos}
                                label='Puerto'
                                fullWidth
                                size='small'
                                variant='outlined' 
                                type='Number'
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <NatureIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                              
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
                            <TextField
                                value={Datos.Frecuencia || ''}
                                name='Frecuencia'
                                onChange={handleDatos}
                                label='Frecuencia'
                                fullWidth
                                size='small'
                                variant='outlined' 
                                type='Number'
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <SettingsInputAntennaIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                              
                            />
                        </Grid>
                        <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
                            <TextField
                                value={Datos.SSID || ''}
                                name='SSID'
                                onChange={handleDatos}
                                label='SSID'
                                fullWidth
                                size='small'
                                variant='outlined'
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <CompassCalibrationIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>
                        <Grid item xl={4} lg={4} md={5} sm={6} xs={12}>
                            <TextField
                                value={Datos.KEY || ''}
                                name='KEY'
                                onChange={handleDatos}
                                label='NV2_KEY'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <VpnKeyIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                            
                            />
                        </Grid>
                        <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                            <TextField
                                value={Datos.Comentario || ''}
                                name='Comentario'
                                onChange={handleDatos}
                                label='Comentario'
                                fullWidth
                                size='small'
                                variant='outlined'                             
                            />
                        </Grid>
                        <Grid item xl={5} lg={6} md={7} sm={12} xs={12}>
                            <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                                <Grid item>OFF</Grid>
                                <Grid item>
                                    <Switch checked={Datos.isLocal || false} onChange={handleSwitchLocal} name="isLocal" color='primary'/>
                                </Grid>
                                <Grid item>ON</Grid>
                                <Grid item>
                                    <Alert severity={Datos.isLocal ? 'success' : 'info'}>                          
                                            Esta Antena esta conectada directamente a su CCR O RB?
                                    </Alert>
                                </Grid>
                            </Grid>            
                        </Grid>        
                    </Grid>
                    <Divider style={{marginTop:10}}/>
                </DialogContent> 
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    
                    <Button size='large' color='primary' startIcon={<SaveIcon/>} variant='contained' onClick={handleEditEquipo} disabled={!isSelectedZona}>
                        {isProcessing ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : 'Guardar'}
                    </Button>
                    <Button size='large' color='secondary' variant='contained' onClick={handleAlertCloseEditInformacion}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>  
            <TrYounetStyled >
                {
                    columns.map((el,index)=>
                        index === 0 ? 
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            <Grid container>
                                <Grid item>
                                    <Tooltip title='STATUS' placement="left" arrow>
                                        <IconButton aria-label="expand row" size="small" onClick={handleInformacionStatus}>
                                            <AccountCircleIcon color='primary'/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title='INF. WIFI' placement="left" arrow>
                                        <IconButton aria-label="expand row" size="small" onClick={handleInformacionAP}>
                                            <SignalWifi4BarIcon color='primary'/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title='TABLA C.P.E' placement="top" arrow>
                                        <IconButton aria-label="expand row" size="small" onClick={handleInformacionCPE}>
                                            <ListAltIcon color='primary'/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title='EDIT' placement="top" arrow>
                                        <IconButton aria-label="expand row" size="small"onClick={handleClickEdit}>
                                            <EditIcon style={{color:'green'}}/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title='ELIMINAR' placement="top" arrow>
                                        <IconButton aria-label="expand row" size="small" onClick={handleAlert}>
                                            <DeleteIcon style={{color:'red'}}/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title='COMMENT' placement="right" arrow>
                                        <IconButton aria-label="expand row" size="small" onClick={()=>{handleComment(rowInfo.Comentario)}}>
                                            <InfoIcon style={{color:'dodgerblue'}}/>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item>
                                    {isInfoCharging && <FacebookCircularProgress size={20} style={{marginTop:5}}/>}
                                </Grid>
                            </Grid>
                        </TdYounetStyled> : index === 1 ? 
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Zona}
                        </TdYounetStyled> : index === 2 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.IP}
                        </TdYounetStyled> : index === 3 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.SSID}
                        </TdYounetStyled> : index === 4 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Frecuencia}
                        </TdYounetStyled> : index === 5 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Marca}
                        </TdYounetStyled> : index === 6 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Modelo}
                        </TdYounetStyled> : index === 7 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Tipo}
                        </TdYounetStyled> : index === 8 ?
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            {rowInfo.Usuario}
                        </TdYounetStyled> :
                        <TdYounetStyled minWidth={columns[index].minWidth} width={columns[index].minWidth} key={`${el}_${index}`}>
                            <>
                                {showPass ? rowInfo.Password : '********************'}
                                <IconButton size='small' onClick={handlePass}>
                                    {showPass ? <VisibilityOffIcon/> : <VisibilityIcon color='secondary' style={{position:'relative', left:3, top:-3}}/>}
                                </IconButton>
                            </>
                        </TdYounetStyled>
                    )
                }

                
                
            </TrYounetStyled>
        </Fragment>
    );
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
};
  
function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    return (
      <TableHead >
        <TableRow style={{display:'flex'}}>
          {columns.map((headCell) => (
            <TheadYounet  
                headCells={columns} 
                key={headCell.id} 
                widthDefault={headCell.minWidth} 
                createSortHandler={createSortHandler} 
                order={order} 
                orderBy={orderBy} 
                headCell={headCell} 
                classes={classes} 
                align={headCell.align}
            />
          ))}
        </TableRow>
      </TableHead>
    );
};

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}

const ListadoEquipo = memo(({data, handleDelete, handleUpdate, dataZona, ModelosList, Marcas, Tipos})=>{
    const size = useWindowSize();
    const [ order, setOrder] = useState('asc');
    const [ orderBy, setOrderBy] = useState('Action');
    const classes = styles();
    const [ page, setPage] = useState(0);
    const [ rowsPerPage, setRowsPerPage] = useState(8);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return( 
        <div style={{ maxWidth: '100%', minWidth:'100%', marginTop:2, overflowX:'auto'}}>
            <TableContainer >
                <Table aria-label="sticky table" size='small' style={{height:size.height === undefined ? 500 : size.height - 220, position:'sticky', top:0}}>
                <Scrollbars
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                >
                <EnhancedTableHead
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={data.length}
                    />
                <TableBody >
                {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => <RowAp key={`${row._id}-${index}`} rowInfo={row} handleDelete={handleDelete} handleUpdate={handleUpdate} dataZona={dataZona} Tipos={Tipos} Marcas={Marcas} ModelosList={ModelosList}/> )}
                </TableBody>
                </Scrollbars>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage='Filas'
            />
        </div>
        
    )

});

const ListadoEquipos= ({data, handleProcess, handleUpdate, handleDelete, dataZona, ModelosList, Marcas, Tipos})=>{
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}>
          <ListadoEquipo data={data} handleProcess={handleProcess} handleUpdate={handleUpdate} handleDelete={handleDelete} dataZona={dataZona} Tipos={Tipos} Marcas={Marcas} ModelosList={ModelosList}/>
        </SnackbarProvider>
    );
};


export default ListadoEquipos;